const CORRELATION_RE = /^[a-f0-9-]{8,64}$/i;

export const CORRELATION_HEADER = "x-correlation-id";

export function generateCorrelationId(): string {
  return globalThis.crypto.randomUUID();
}

export function validateCorrelationId(value: string | null | undefined): string {
  if (!value || typeof value !== "string") return generateCorrelationId();
  return CORRELATION_RE.test(value) ? value : generateCorrelationId();
}

